import { render } from "./ProductGroups.vue?vue&type=template&id=3149d0a1&scoped=true&ts=true"
import script from "./ProductGroups.vue?vue&type=script&lang=ts"
export * from "./ProductGroups.vue?vue&type=script&lang=ts"

import "./ProductGroups.vue?vue&type=style&index=0&id=3149d0a1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3149d0a1"]])

export default __exports__